






import ExamEditor from './components/ExamEditor.vue'
import { Component, Vue } from 'vue-property-decorator'
Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    ExamEditor,
  },
})
export default class EditExam extends Vue {
  private canLeave: boolean = false
  private beforeRouteLeave(to, from, next): void {
    if (!this.$store.state.forceBack) {
      if (!this.canLeave) {
        this.$confirm({
          title: this.$t('common.unsaveConfirm'),
          onOk: () => {
            next()
          },
          onCancel: () => {
            next(false)
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
  private created(): void {}
}
